

var onLoadData= {
  init:function(){
    var $tab = $('.module-interior.style-guide-wrapper.show');
    //console.log($tab.length);
    if($tab.length > 0){
      //var $t = $tab.find(".swiper-slide-active");
      var $t = $tab.find(".swiper-slide.swiper-slide-active");
      var $img=$t.find(".picture__img");
      //         console.log($img);
      var $img_src=$img[0].src;
//       console.log($img_src);

      var $btn=$('.skip-btn-style.tab.type-e.active');

      var $heading=$btn.data("heading");
      var $sub_heading=$btn.data("sub-heading");
      var $id=$btn.data("id"); 
      var $featured_image=$btn.data("featured-image");
     // console.log($featured_image);
      //console.log($id);

      var $block_swiper=$('.'+$id+'');                             
    

//       $('#tab__image').attr('src', $featured_image);
//       $("#tab_heading").html($heading);
//       $("#tab_sub_heading").html($sub_heading);
      // console.log($heading);
      //console.log($sub_heading);
    }
  }
}

var onClickData= {
  init:function(){
    $('.skip-btn-style.tab').on('click', function() {
      //               var $tab = $('.module-interior');  
      var $tab = $('.module-interior.style-guide-wrapper.show');
      var $t = $tab.find(".swiper-slide.swiper-slide-active");
      var $img=$t.find(".picture__img");
      //console.log($tab);
      var $img_src=$img[0].src;
           
      
      $('.skip-btn-style').removeClass('active');
      $(this).addClass('active');
      
      var $featured_image=$(this).data("featured-image");
      //console.log($featured_image);
      var $heading=$(this).data("heading");
      var $sub_heading=$(this).data("sub-heading");


      var $id=$(this).data("id"); 
      //console.log($id);

      var $all_block=$('.module-interior.style-guide-wrapper');
      //console.log($all_block);
      $all_block.addClass("hide").removeClass("show");
      var $block_swiper=$('.'+$id+'');                             
      //console.log($block_swiper);
      $block_swiper.removeClass("hide").addClass("show"); 

      var $activa_guide_swiper=$('.module-interior.style-guide-wrapper.'+$id+'.show');     

//       $('#tab__image').attr('src', $featured_image);
//       $("#tab_heading").html($heading);
//       $("#tab_sub_heading").html($sub_heading);
    
    });
  }
}

// Style Guide Module Tab Click   
var style_guide_module= {
  init:function(){
    var $s = $("#page-content");
    $s.find(".swiper-container").each(function() {
      var $tab = $('.module-interior.style-guide-wrapper');
      if($tab.length > 0){
        onLoadData.init();
        onClickData.init();
      }
    })
  }
}

// product-recommendations.liquid

function initSlider($t){
  var prs  = new Swiper($t, {
    slidesPerView: 'auto',
    autoplay: false,
    loop:true,
    simulateTouch: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        navigation: true,
        loop: true,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      640: {
        slidesPerView: 1,
        navigation: true,
        loop: true,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      480: {
        slidesPerView: 1,
        navigation: true,
        loop: true,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      320: {
        slidesPerView: 1,
        navigation: true,
        loop: true,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  });
}

var loadProductRecommendationsIntoSection = function() {
 
  var productRecommendationsSection = document.querySelector("#related-product-content");  
	console.log('productRecommendationsSection');

  if (productRecommendationsSection === null) { return; }
 
  var productId = productRecommendationsSection.dataset.productId;
//  	console.log(productId);

  var limit = productRecommendationsSection.dataset.limit;
// 	console.log(limit);

  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
       console.log('inside XML');
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector("#related-product-content").innerHTML;
      var $t = productRecommendationsSection.querySelector(".js-related-prods-slider");     
      initSlider($t); 	    
    }
  };
  request.send();
//   var $t2= productStyleWithSection.querySelector(".js-style-prods-slider");
//   console.log($t2);
//   initSlider($t2);
};

$(document)
.on('shopify:section:load', function(e){

  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if($parentSection.hasClass('style-guidemodule-wapper')){

    style_guide_module.init();
  }
  if ($parentSection.hasClass('product-recommendations-wrapper')) {
    //     loadProductRecommendationsIntoSection();
  }
})
$(document).on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;	
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  //  console.log($parentSection)
  if($parentSection.hasClass('style-guidemodule-wapper')){
    //  console.log('shopify:block:select');
    style_guide_module.init();
  }
  if($parentSection.hasClass('product-recommendations-wrapper')){
    //     loadProductRecommendationsIntoSection();
  }
})
$(document).ready(function(){
//   console.log('extra func');
  style_guide_module.init();
  
  var $productRecommendation=$('.product-recommedation-with-style');     
  if($productRecommendation.length>0){
//         setTimeout(() => {
//                    loadProductRecommendationsIntoSection();
  }
  
  var giftPage=$(".product--gift-card");
  if(giftPage.length>0){
//   	console.log('giftPage');
    var ab=$(".product_sizes .option--size .option-bucket .selected-size .selected-val").text("Select Amount");
//     console.log(ab);
  }

  //   work friends popup
  var $workFriend=$('.modal.modal-work-friends-cta-popup');
  if($workFriend.length > 0){
    //console.log($workFriend);

//     $('.block-content .block-work-friends-popup').on('click',function(){
//       var $id=$(this).data("id");
//       var $attr="work-friends-popup-"+$id;
//       var $collection=$(this).data('collection');
//       //console.log($id);    

//       // console.log($collection);
//       var $className=".modal-work-friends-cta-popup.popup--"+$id;
//       //  console.log($className);
//       //       if($collection !== undefined ){      	
//       $($className).addClass('active');      
//       //       }

//     });
  }
  //   work friends popup

  //   collcetion promo add class
  var $gridItem=$('.grid-item.grid-item-promo');
  if($gridItem.length > 0){
//     console.log($gridItem);
    var $gridAddClass=$(".collection-grids .grid-item-promo .block-content .block-text a");        
    $($gridAddClass).addClass('cta-link image__cta');      
  }

  // work friends popup slider
  var workFriendsSlider = new Swiper('.work-friends-inner-body.swiper-container', {
    slidesPerView: 'auto', 
    autoplay: false,
    simulateTouch: true,
    navigation: false,
    disableOnInteraction: false,
    enteredSlides: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        loop: false,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      640: {
        slidesPerView: 1,
        loop: false,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  });

  // work friends popup slider
  var swiper_opts = {
    slidesPerView: 4,
    autoplay: false,
    loop:false,
    simulateTouch: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        loop: false,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      640: {
        slidesPerView: 1,
        loop: false,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      480: {
        slidesPerView: 1,
        loop: false,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      320: {
        slidesPerView: 1,
        loop: false,
        draggable:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  };
  let prs2,prs3;
  function initProdRelatedSliders(){
//     console.log("S.isMobile",$(window).width())
    if($(window).width()<768){
      if(!$('.js-style-prods-slider').hasClass('swiper-container-initialized')){
        prs2  = new Swiper($('.js-style-prods-slider'), swiper_opts);
//         console.log('swiper initialized 1')
      }
      if(!$('.js-related-prods-slider').hasClass('swiper-container-initialized')){
        prs3  = new Swiper($('.js-related-prods-slider'), swiper_opts);
//         console.log('swiper initialized 2')
      }
    }
    else{
      if($('.js-style-prods-slider').hasClass('swiper-container-initialized') && $('.js-style-prods-slider .swiper-slide').length <= 4){
        try{prs2.destroy();}
        catch(ex){console.log(ex)}
//         console.log('destroy 1')
      }
      else{
//          console.log('else destroy 1')
      }
      if($('.js-related-prods-slider').hasClass('swiper-container-initialized') && $('.js-related-prods-slider .swiper-slide').length < 4){
        try{prs3.destroy();}
        catch(ex){console.log(ex)}
//         console.log('destroy 2')
      }
      else{
//         console.log('else destroy 2')
      }
    }
  }
  //   product recommendation with product with style
  var $productRecommendation=$('.product-recommedation-with-style');     
  if($productRecommendation.length>0){
//         setTimeout(() => {
//                    loadProductRecommendationsIntoSection();
//       }, 500);
          
    var $StyleTab=$('.product-recommedation-with-style .tabs  #style-with-product');
    var $RelatedTab=$('.product-recommedation-with-style .tabs  #related-product');

    var $StyleContent=$('.product-recommedation-with-style .product-content  #style-with-product-content');
    var $RelatedContent=$('.product-recommedation-with-style .product-content #related-product-content');
    
    
//     console.log("isMobile",S.isMobile)
    $($StyleTab).on('click', function(e) {
       e.preventDefault();
      //       alert('style');
      //       console.log($RelatedTab);
      //       console.log($StyleTab);
      $RelatedTab.removeClass("active");
      $(this).addClass("active");
      $RelatedContent.addClass("hidden");
      $StyleContent.removeClass("hidden");
      initProdRelatedSliders();
    });

    $($RelatedTab).on('click', function(e) {
       e.preventDefault();
      //       alert('related');
      //       console.log($RelatedTab);
      //       console.log($StyleTab);
      $StyleTab.removeClass("active");
      $(this).addClass("active");

      $StyleContent.addClass("hidden");
      $RelatedContent.removeClass("hidden");
      initProdRelatedSliders();
      //           var prs2  = new Swiper($('.js-style-prods-slider'), swiper_opts);
    });

    initProdRelatedSliders();
    $(window).on('resize',function() {
      initProdRelatedSliders();
    })
  }

  
  var workFriendsCTA=$('.work-friends-home-image-cta');
  if(workFriendsCTA.length>0){
//   	console.log('workFriendsCTA');
    var img_cta=$('.work-friends-home-image-cta .cta-link.image__cta[data-id],.image-video-banner-section .cta-link.image__cta[data-id]');
    $(img_cta).on('click',function(){
      var $id=$(this).data("id");
      console.log($id);
      // console.log($collection);
      var modal_popup=$('.full-looks[data-drawer-id="'+$id+'"]');
      if($(modal_popup).length>0){
        $('.full-looks').removeClass('active');
        $('.full-looks[data-drawer-id="'+$id+'"]').addClass('active');
        $('html').addClass('disabled-scroll');
//         var el = $('.full-looks[data-drawer-id="'+$id+'"]').find('[body-scroll-lock-ignore]');
//         console.log(el)
//         S.scroll.disable(el);
//         console.log($('.full-looks[data-drawer-id="'+$id+'"]'));
      }
    });
  }

  setTimeout(function(){
    console.log('ticker loading, width: ',$('.strHtml').width()); 
    $('.strHtml').liMarquee({circular:true, startShow:true, scrolldelay: 0,scrollamount:400,drag:false,hoverstop:false});
    console.log('ticker loaded');
  }, 200);

  $('.addto-wishlist-trigger').on('click',function(e){
    e.preventDefault();
    $this = $(this);
    var $parent = $(this).parents('form.order-form.addtoform');
    //           console.log($parent)
    var prodJson = JSON.parse($(this).attr('data-product'));
    var variantJson = JSON.parse($(this).attr('data-variant-info'));
    var isSizeSelected = JSON.parse($parent.find('.selected-size span.selected-val').attr('data-selected').toLowerCase());
    $parent.find('.selected-size').removeClass('error');
    var active_size = $parent.find('select.order-form__variants option:selected');
    var prodId = Number($(this).attr('data-product-id'));
    if(isSizeSelected){
      //             console.log(Number(active_size.val()),active_size.text())
      var variant_stock = Number(active_size.attr('data-var_stock'));
      var variant_price = Number(active_size.attr('data-price')).toFixed();
      var variant_id = Number(active_size.val());
      var variant_option = String(active_size.text());
      if(typeof window._swat.addToWishList == 'function'){
        var prodImage = $(this).attr('data-fallback-image');
        var color = active_size.attr('data-color');
        var size = active_size.attr('data-size');
        var prodURL = "https://"+$(this).attr('data-product-handle');
        var key = variant_option;
        var person = { [key]:variant_id };
        var myArray = Array();
        myArray.push(person)
        //               console.log(prodURL);
        var obj = {
          "epi": variant_id,
          "du": prodURL,
          "empi": prodId,
          "iu" : prodImage,
          "pr": variant_price,
          "stk": variant_stock,
          "variants": myArray,
          "cprops":{'size':size,'color':color,vid:variant_id}
        };
        //              console.log('Wishlist Object: '+obj)
        window._swat.addToWishList(
          obj,
          function(r) {
            $('.addto-wishlist-trigger').css('display','none');
            $('.wishlist_notification').css('display','inline-block');
            setTimeout(function(){
              $('.wishlist_notification').css('display','none');
              $('.addto-wishlist-trigger').css('display','inline-block');  
            }, 12000);
            console.log('Added to wishlist');
          });
        return true;
      }
    }
    else{
      $parent.find('.js-mobile-options .option--size .selected-val:eq(0)').addClass('error');
      $parent.find('.selected-size').addClass('error');
      return false;
    }
  });

  function cloneSwymStyleTag(){
    if(typeof SwymUtils == 'object'){
      SwymUtils.onDOMReady(function() {
        if($('#swym-style-tag').length){
          $('#swym-style-tag').remove();
        }
      })
    }
  }

  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(cloneSwymStyleTag);




  $('a.js-showmore-trigger').on('click',function(e){
    e.preventDefault();
    var $this = $(this),
        parent = $this.parent().siblings('[data-enable-showmore="true"]'),
        next = parseInt(parent.next('.showmore-wrapper').attr('data-next-showmore')),
        elemts = parent.find('[showmore-blocks]'),
        visible_blocks = parent.find('[showmore-blocks]:visible'),
        hidden_block = parent.find('[showmore-blocks]:hidden');
    //     console.log(next)
    if(hidden_block.length != 0){
      parent.find('[showmore-blocks]:hidden').slice(0,next).show();
      //       console.log(parent.find('[showmore-blocks]:hidden').length)
      if(parent.find('[showmore-blocks]:hidden').length==0){
        $this.hide();
      }
    }
    else{
      $this.hide();
    }
  })

  $('[data-ambassador-popup-trigger]').on('click',function(e){
    e.preventDefault();
    S.scroll.disable();
    $('html').css({overflow: 'hidden'});
    $('.thankyou-popup').hide();
    $('#ambassador-popup .job-popup__content').show();
    $("#ambassador-popup").addClass('active');
    
  })

  $('[data-login-popup-trigger]').on('click',function(e){
    e.preventDefault();
    $('html').css({overflow: 'hidden'});
    $('#login-popup .content-box').show();
    $("#login-popup").addClass('active');
    
  })
  

  if($("form.jotform-form").length>0){  
    $("form.jotform-form").validate({
      invalidHandler: function(form, validator) {
        var errors = validator.numberOfInvalids();
        console.log(errors)
        if (errors) {
          //resize code goes here
        }
      },
      success: function(label) {
//         console.log(label)
        label.parents('.form-line').removeClass('error');
      },
      errorPlacement: function(error, element) {
        
        if (element.attr("type") == "radio" || element.attr("type") == "checkbox") {
          element.parents('.form-line').removeClass('error');
          element.parents('.form-line').addClass('error').find('div.form-input-wide').after(error)
//           element.parents('.form-label.form-label-top.form-label-auto').addClass('error')
        } else {
//           if(!element.hasClass('error')) element.addClass('error')
          element.after(error);
        }
      },
      submitHandler: function(form) {
        form.submit();
      }
    });
  }
  
})/*Write code before this line*/

